<ng-container *ngIf="hasReportReadPermission">
    <!-- 帮助提示 -->
    <div class="report-help-container" *ngIf="reportDatas.length !== 0">
        <app-smart-assistant-switch [content]="i18n.helpTitle" [showIcon]="false"></app-smart-assistant-switch>
    </div>

    <div class="report-object-container">
        <n-loading [visible]="loading"></n-loading>
        <app-smart-assistant-object-container icon="#app-icon-simple-report"
            *ngFor="let report of reportDatas; index as i"
            [id]="'report-object-' + i"
            [name]="report.file_name"
            [operateLabel]="i18n.exportReport"
            (onClick)="exportReport(report)">
        </app-smart-assistant-object-container>
    </div>
</ng-container>
